"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.OracleScrollIndicator = void 0;
var react_1 = __importDefault(require("react"));
var icons_1 = require("./icons");
var StaticTextContext_1 = require("./StaticTextContext");
var OracleScrollIndicator = function (_a) {
    var isVisible = _a.isVisible, onClick = _a.onClick, _b = _a.className, className = _b === void 0 ? '' : _b;
    var scrollToBottomLabel = (0, StaticTextContext_1.useTranslatedText)({ keys: ['accessibility', 'scrollToBottom'] });
    if (!isVisible) {
        return null;
    }
    return (react_1.default.createElement("button", { className: "oracle-scroll-indicator ".concat(className).trim(), onClick: onClick, type: "button", "aria-label": scrollToBottomLabel }, (0, icons_1.makeIcon)('arrow-down', '16px')));
};
exports.OracleScrollIndicator = OracleScrollIndicator;
exports.default = OracleScrollIndicator;
